<template>
  <div class="page appoint">
    <div class="icon icon-logo abs"></div>
    <div class="footer-logo">
      <i class="icon icon-mg-logo"></i>
      <i class="icon icon-vip"></i>
    </div>
    <div class="rule-entry" @click="showRuleDialog = true">活动介绍</div>
    <div class="pannel-wrapper">
      <div class="pannel">
        <div class="icon icon-ear"></div>
        <div class="center-line"></div>
        <div class="pannel-content">
          <p>让我们说悄悄话，说到沙哑</p>
          <p>这里整夜有光，如果你也怕黑的话</p>
        </div>
      </div>
    </div>
    <div class="btn-wrapper">
      <div class="icon icon-cat4 abs"></div>
      <div class="btn" @click="appointHandler">立即预约</div>
    </div>
    <div class="tips-wrapper">
      <p><span class="tips-vip" @click="vipEntry">成为会员</span>享更多权益</p>
      <p class="tips-time">本次预约截止时间：{{overTime}}</p>
    </div>
    <rules-dialog :showDialog.sync="showRuleDialog" />
    <info-dialog :showDialog.sync="showInfoDialog" :originInfo="liveInfo" @showMessage="infoHandler" />
    <toast ref="toast" />
  </div>
</template>

<script>
import LoginSDK from "@/utils/login";
import * as Apis from "@/apis";
import RulesDialog from './components/RulesDialog'
import InfoDialog from './components/InfoDialog'
import { OVER_TIME, RESERVE_NUM } from './constans'


export default {
  components: {
    RulesDialog,
    InfoDialog,
  },
  data() {
    return {
      showRuleDialog: false,
      showInfoDialog: false,
      liveInfo: null,
      overTime: OVER_TIME,
    }
  },
  methods: {
    vipEntry() {
      LoginSDK.linkToActServerWithTarget('https://club.mgtv.com/act/mgtv_cashier/index.html?isHideNavBar=1&isFullScreen=1&ftype=5&source=pyqth2')
    },
    infoHandler(msg) {
      this.$refs.toast.onShowToast(msg);
    },
    async appointHandler() {
      await this.fetchDetail();
      this.showInfoDialog = true;
    },
    async fetchDetail() {
      const { uuid } = this.dataStore.getInfo();
      const data = JSON.stringify(this.dataStore.getInfo());
      if (!uuid) {
        LoginSDK.login();
        return;
      }
      try {
        const data = await Apis.getLiveInfo({ uuid, order_type: RESERVE_NUM });
        this.liveInfo = data;
      } catch (error) {
        this.liveInfo = null;
      }
    },
  },
};
</script>

<style lang="scss">
@import "~@/assets/mixins.scss";

.appoint{
  .rule-entry{
    position: absolute;
    right: 0;
    @include px2vw(top, 86);
    @include px2vw(width, 44);
    // @include px2vw(height, 170);
    line-height: 1.5;
    @include px2vw(padding-top, 12);
    @include px2vw(padding-bottom, 10);
    @include px2vw(padding-right, 2);
    @include px2vw(font-size, 26);
    @include px2vw(border-top-left-radius, 20);
    @include px2vw(border-bottom-left-radius, 20);
    line-height: 1.5;
    background-color: #668DF7;
    color: #fff;
    text-align: right;
  }
  .btn {
    &-wrapper {
      position: relative;
      @include px2vw(width, 274);
      margin: 0 auto;
      @include px2vw(margin-top, 180);
    }
    background-image: url("~@/assets/img/btn.png");
    &.disabled {
      background-image: url("~@/assets/img/btn-dis.png");
    }
    @include px2vw(width, 274);
    @include px2vw(height, 116);
    @include px2vw(line-height, 116);
    @include px2vw(font-size, 42);
    font-weight: bold;
    & + .btn {
      @include px2vw(margin-top, 30);
    }
  }
  .pannel {
    &-wrapper {
      @include px2vw(margin-top, 320);
      @include px2vw(font-size, 24);
      @include px2vw(line-height, 40);
      color: #333333;
    }
    position: relative;
    @include px2vw(padding-left, 100);
    @include px2vw(padding-right, 30);
    margin: 0 auto;
    display: flex;
    flex-flow: row nowrap;
    justify-content: center;
    align-items: center;

    .center-line{
      @include px2vw(width, 8);
      @include px2vw(height, 204);
      background-color: #000;
      @include px2vw(margin-left, 40);
      @include px2vw(margin-right, 30);
    }
  }
  .icon {
    &-logo {
      @include px2vw(top, 20);
      @include px2vw(left, 30);
    }
    &-mg-logo {
      @include px2vw(bottom, 22);
      @include px2vw(right, 30);
    }
    &-cat4 {
      @include px2vw(top, 70);
      @include px2vw(left, 260);
    }
  }
  .tips{
    &-wrapper{
      @include px2vw(margin-top, 35);
      @include px2vw(font-size, 24);
      text-align: center;
      
    }

    &-vip{
      display: inline-block;
      @include px2vw(margin-right, 10);
      @include px2vw(line-height, 1.5);
      color: #5176D9;
      text-decoration: underline;
    }

    &-time{
      @include px2vw(margin-top, 25);
    }
    
  }
}
</style>
